import { render, staticRenderFns } from "./ShockGenMetalHome.vue?vue&type=template&id=68ae32e8&scoped=true&"
import script from "./ShockGenMetalHome.vue?vue&type=script&lang=js&"
export * from "./ShockGenMetalHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ae32e8",
  null
  
)

export default component.exports